import { GlobalGoogleAnalyticsState } from ".";

export function incrementCountItemsPresentInstanceListError(state:GlobalGoogleAnalyticsState) {
  state.instanceListCountItemsPresentErrorCount += 1;
}

export function markPreviewPageAsVisited(state:GlobalGoogleAnalyticsState) {
  state.previewPageHasBeenVisited = true;
}